import { UserMe } from 'types/api/User';

export function hasLearningResourcesSubscription(currentUser: UserMe) {
  return (
    currentUser.roles.includes('lr_coach') ||
    currentUser.roles.includes('lr_educator')
  );
}
